export default __webpack_public_path__ + "static/media/382.9a81ee27.gif";